import Image from 'next/image';
import Link from 'next/link';

import { sanitizeUrl } from '@/helpers/storyblokLink';
import { getStoryblokImageUrl } from '@/lib/utils';

import Heading from '../Heading';
import PreHeading from '../PreHeading';
import Prose from '../Prose';
import Text from '../Text';

export enum ListingOrientation {
  HORIZONTAL,
  VERTICAL,
}

const LAYOUT_MODE = {
  [ListingOrientation.HORIZONTAL]: 'grid grid-cols-3 gap-6 md:gap-8 xl:gap-12',
  [ListingOrientation.VERTICAL]: '',
};

export default function Project({
  hero_heading,
  hero_feature_image,
  alt_feature_image,
  preview,
  tags,
  full_slug,
  orientation = ListingOrientation.VERTICAL,
}) {
  return (
    <Link
      href={sanitizeUrl(full_slug)}
      className={`group relative cursor-pointer ${LAYOUT_MODE[orientation]}`}
    >
      <>
        <div className="col-span-1">
          <div
            className={`relative w-full self-start transition-transform duration-700 ease-smooth hover:duration-200 group-hover:scale-[1.025] ${
              orientation === ListingOrientation.HORIZONTAL
                ? 'aspect-square align-middle'
                : 'aspect-video'
            }`}
          >
            <Image
              alt={hero_feature_image?.alt}
              src={
                alt_feature_image?.filename
                  ? getStoryblokImageUrl(alt_feature_image?.filename)
                  : getStoryblokImageUrl(hero_feature_image?.filename)
              }
              fill
              sizes="100vw"
              className="object-cover"
            />
          </div>
        </div>
        <div className="col-span-2 self-center md:py-4">
          <div className="space-y-4">
            <div className="space-y-3">
              <div className="flex flex-row flex-wrap gap-x-4 gap-y-1 align-middle">
                {tags?.map((t) => (
                  <PreHeading
                    key={t}
                    size="xs"
                    element="div"
                    color="text-theme-darkgrey"
                    className="rounded-full bg-theme-lightgrey px-3 py-1.5 font-extralight leading-none tracking-widest text-theme-darkgrey"
                  >
                    {t}
                  </PreHeading>
                ))}
              </div>
              <div className="space-y-4">
                <Heading size="xs" className="font-semibold">
                  {hero_heading}
                </Heading>
                <div className="line-clamp-3 empty:hidden">
                  <Prose size={'sm'} color="neutral" content={preview} />
                </div>
              </div>
            </div>

            <Text size="base" className="font-medium text-theme-primary">
              Read More
            </Text>
          </div>
        </div>
      </>
    </Link>
  );
}
